import { observer } from 'mobx-react-lite'
import { Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import GroupsIcon from '@mui/icons-material/Groups'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { ColorTokens, Palette } from 'src/feature/theme/model/Palette'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { ReactNode } from 'react'

type ProjectOverviewCardsProps = {
  projectCount: number
  onCreateProject: () => void
}

type ActionTileProps = {
  label: string
  value?: string | number
  icon: ReactNode
  onClick?: () => void
}

function ActionTile({ label, value, onClick, icon }: ActionTileProps) {
  return (
    <AppBox sx={styles.createButton} onClick={onClick}>
      <AppBox sx={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>{label}</Typography>
        <AppBox sx={styles.createIconTile}>{icon}</AppBox>
      </AppBox>
      <Typography variant="h2">{value}</Typography>
    </AppBox>
  )
}

export const ProjectOverviewCards = observer(({
  projectCount,
  onCreateProject,
}: ProjectOverviewCardsProps) => {
  const { translation } = useLocalizationStore()
  const projectBuilderTranslation = translation.pages.projectBuilder

  return (
    <AppBox sx={styles.container}>
      <ActionTile
        label={projectBuilderTranslation.createProjectButton()}
        onClick={onCreateProject}
        icon={<AddIcon sx={styles.createIcon} />}
      />

      <ActionTile
        label={projectBuilderTranslation.allProjects()}
        value={projectCount}
        icon={<GroupsIcon sx={styles.createIcon} />}
      />
    </AppBox>
  )
})

const styles = {
  container: {
    display: 'flex',
    gap: 20,
    width: '100%',
  },
  createButton: {
    flexDirection: 'column',
    borderRadius: '12px',
    backgroundColor: ColorTokens.neutral100,
    padding: '10px 15px',
    minWidth: 180,
    gap: 5,
    cursor: 'pointer',
  },
  createIconTile: {
    width: 38,
    minWidth: 38,
    height: 38,
    borderRadius: '12px',
    backgroundColor: ColorTokens.primary200,
    alignItems: 'center',
    justifyContent: 'center',
  },
  createIcon: {
    fontSize: 30,
    color: Palette.CORAL_REEF_GREEN,
  },
} as const